import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { USER_PREFERENCE_API } from "../apiRoutes";

const mutateAddUserPreference = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${USER_PREFERENCE_API}`, data);
};

const useAddUserPreferenceMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddUserPreference,
    ...queryParams,
  });

export default useAddUserPreferenceMutation;
